import {
  ArrowLeftIcon,
  CalendarIcon,
  DocumentTextIcon,
  ExclamationTriangleIcon,
  RocketLaunchIcon,
  UsersIcon
} from '@heroicons/react/24/outline'
import { API, Auth } from 'aws-amplify'
import Papa from 'papaparse'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import Modal from '../../components/Modal'
import ResultModal from '../../components/ResultModal'
import ExcelClosingSummary from '../../components/ExcelClosingSummary'
import i18n from '../../i18n'
import { apiGet, apiPost } from '../../libs/apiHelper'
import { useAppContext } from '../../libs/context'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Send = () => {
  const { selectedCampaign, stat, contacts, excelJob, updateNav, onStepClick } =
    useAppContext()
  const [open, setOpen] = useState(false)
  const [userFullInfo, setUserFullInfo] = useState({})
  const [resultContent, setResultContent] = useState({})
  const [openResult, setOpenResult] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [scheduled, setScheduled] = useState(false)
  const [scheduleDate, setScheduleDate] = useState('')
  const [scheduleTime, setScheduleTime] = useState('')
  const [confirmLaunch, setConfirmLaunch] = useState(false)
  const [forceSMS, setForceSMS] = useState(false)
  const [syncSftpResults, setSyncSftpResults] = useState(false)
  const [resultFunction, setResultFunction] = useState(false)
  const [modalContent, setModalContent] = useState({})
  const [selectedBotId, setSelectedBotId] = useState(null)
  const [userBots, setUserBots] = useState([])

  const history = useHistory()

  const modalMsgs = {
    pre: {
      title: 'Lanza la campaña',
      content: `Vas a lanzar la campaña ${selectedCampaign?.name} a ${stat?.users}`,
      cta: 'Lanzar'
    },
    post: {
      title: i18n.t('campaign_launched'),
      content: i18n.t('check_stats'),
      cta: 'Ok'
    },
    error: {
      title: i18n.t('error_launching'),
      content: i18n.t('could_not_launch'),
      cta: 'Error'
    }
  }

  function goStatistics() {
    console.log('se activa campaigns')
    setOpenResult(false)
    history.push('/campaigns')
    updateNav('/campaigns')
  }

  const getUserFullInfo = async () => {
    try {
      // Usar el helper que automáticamente incluye el token de impersonación si está disponible
      const resp = await apiGet('/user')
      setUserFullInfo(resp)

      // Load bots from botData and set default selection
      // botData can be array (new format) or object (legacy - will be converted in ProviderConfiguration)
      if (resp.botData) {
        if (Array.isArray(resp.botData) && resp.botData.length > 0) {
          setUserBots(resp.botData)
          // Select first bot by default
          if (!selectedBotId) {
            setSelectedBotId(resp.botData[0].id)
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const hasEnoughBalance = () => {
    if (userFullInfo.paymentType && userFullInfo.paymentType === 'POST') {
      return true
    }
    const balance = userFullInfo.balance ? userFullInfo.balance : 0
    const costPerRBM = userFullInfo.costPerRBM ? userFullInfo.costPerRBM : 0.04
    const costPerSMS = userFullInfo.costPerSMS ? userFullInfo.costPerSMS : 0.04
    const highCost = costPerRBM >= costPerSMS ? costPerRBM : costPerSMS
    const minBalance =
      typeof userFullInfo.minBalance !== 'undefined'
        ? userFullInfo.minBalance
        : balance

    if (balance < highCost * stat.users) {
      const capacity = Math.floor(balance / highCost)
      setResultContent({
        title: i18n.t('insufficient_balance'),
        content: i18n.t('numbers_capacity', { capacity: capacity }),
        cta: 'Error'
      })
      return false
    }
    if (minBalance < highCost * stat.users) {
      setResultContent({
        title: i18n.t('insufficient_min_balance'),
        content: i18n.t('wait_charge'),
        cta: 'Error'
      })
      return false
    }
    return true
  }

  useEffect(() => {
    getUserFullInfo()
    // Inicializar modalContent
    setModalContent(modalMsgs.pre)
  }, [])

  // Protección: si no hay datos necesarios, mostrar mensaje
  if (!selectedCampaign || !contacts || contacts.length === 0) {
    const missingTemplate = !selectedCampaign
    const missingContacts = !contacts || contacts.length === 0

    return (
      <div className="py-12">
        <div className="w-full max-w-md mx-auto text-center">
          <ExclamationTriangleIcon className="mx-auto h-12 w-12 text-yellow-400" />
          <h3 className="mt-4 text-lg font-medium text-gray-900">
            {i18n.t('cannot_send_campaign') || 'Cannot send campaign'}
          </h3>
          <div className="mt-2 text-sm text-gray-500">
            {missingTemplate && (
              <p>
                {i18n.t('select_template_first') ||
                  'Please select a template first'}
              </p>
            )}
            {missingContacts && (
              <p>
                {i18n.t('upload_contacts_first') ||
                  'Please upload contacts first'}
              </p>
            )}
          </div>
          <div className="mt-6 flex justify-center space-x-3">
            {missingTemplate ? (
              <button
                type="button"
                onClick={() => onStepClick({ id: 1, href: 'select' }, true)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-dark hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dark"
              >
                <ArrowLeftIcon className="-ml-1 mr-2 h-4 w-4" />
                {i18n.t('go_to_select_template') || 'Select template'}
              </button>
            ) : (
              <button
                type="button"
                onClick={() => onStepClick({ id: 2, href: 'upload' }, true)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-dark hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dark"
              >
                <ArrowLeftIcon className="-ml-1 mr-2 h-4 w-4" />
                {i18n.t('go_to_upload_contacts') || 'Upload contacts'}
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }

  const campaignLaunch = async () => {
    let scheduleDateTime = ''
    let endpoint = '/campaign'
    if (scheduled) {
      endpoint = '/schedule'
      scheduleDateTime = new Date(
        new Date(scheduleDate).setHours(scheduleTime.split(':')[0])
      )
      scheduleDateTime = scheduleDateTime
        .setMinutes(scheduleTime.split(':')[1])
        .toString()
    }

    // Campaña basada en Excel CaixaBank: no pasa por /campaign (que trata los
    // `phones` como contactos sueltos); usa /process-excel para crear la campaña
    // Y cerrar los flujos (duplicados + SEGUIMIENTO). Si es programada, guarda un
    // schedule de tipo `excel` que launchSchedules invocará a la hora.
    if (excelJob) {
      try {
        if (scheduled) {
          await apiPost('/schedule', {
            body: {
              type: 'excel',
              source: { type: 'base64', data: excelJob.base64 },
              flow: excelJob.flow,
              scheduleDateTime,
              forceSMS,
              force: excelJob.force === true,
              botId: selectedBotId
            }
          })
        } else {
          await apiPost('/process-excel', {
            body: {
              source: { type: 'base64', data: excelJob.base64 },
              flow: excelJob.flow,
              forceSMS,
              force: excelJob.force === true,
              botId: selectedBotId
            }
          })
        }
        setResultContent(modalMsgs.post)
        setResultFunction(true)
      } catch (err) {
        setResultContent(modalMsgs.error)
        alert('Campaign not launched \n' + err)
      }
      return
    }

    const campaignData = {
      phones: contacts.map((p) => {
        delete p.key
        return p
      }),
      flow: selectedCampaign.initElement,
      schema: selectedCampaign.schema,
      scheduleDateTime: scheduleDateTime,
      forceSMS: forceSMS,
      syncSftpResults: syncSftpResults,
      botId: selectedBotId // Include selected bot ID
    }

    try {
      // apiPost respeta el "ver como": si hay impersonación activa, la campaña
      // se crea bajo el usuario impersonado (no bajo el admin).
      const resp = await apiPost('/campaign-file', {
        body: campaignData
      })
      console.log(resp)

      //if too much data use the s3 bucket in server side
      if (campaignData.phones.length > 50) {
        campaignData.phones = []
      }

      campaignData.fileName = resp.fileName
      const campaignResult = await apiPost(endpoint, {
        body: campaignData
      })
      console.log('result', campaignResult)
      setResultContent(modalMsgs.post)
      setResultFunction(true)
    } catch (err) {
      setResultContent(modalMsgs.error)
      alert('Campaign not launched \n' + err)
    }
  }

  const handleLaunchClick = async () => {
    if (selectedCampaign && stat?.users > 0) {
      if (hasEnoughBalance()) {
        //setOpen(true)
        //TODO campaignLaunch todavia no esta terminado
        setIsLoading(true)
        setOpenResult(true)
        await campaignLaunch()
        setIsLoading(false)
        setResultContent(modalMsgs.post)
      } else {
        setOpenResult(true)
      }
    }
  }
  const getDistribution = async () => {
    const user = await Auth.currentAuthenticatedUser()
    console.log(user.signInUserSession.idToken.jwtToken)
    try {
      const distribution = await API.post('rcs-api', '/numbers-distribution', {
        headers: {
          Authorization: user.signInUserSession.idToken.jwtToken
        },
        body: { phones: contacts.map((c) => c.phone) }
      })
      return distribution
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const handleDistributionClick = async () => {
    const distribution = await getDistribution()
    console.log(distribution)
    let distributionList = []
    if (distribution.numbersRcs && distribution.numbersRcs.length > 0) {
      for (let n of distribution.numbersRcs) {
        console.log('añadimos', n)
        distributionList.push({
          number: n,
          type: 'RCS'
        })
      }
    }
    if (distribution.numbersSms && distribution.numbersSms.length > 0) {
      for (let n of distribution.numbersSms) {
        distributionList.push({
          number: n,
          type: 'SMS'
        })
      }
    }
    console.log('la dist', distributionList)
    const csv = Papa.unparse(distributionList)
    const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const csvURL = window.URL.createObjectURL(csvData)
    const tempLink = document.createElement('a')
    tempLink.href = csvURL
    tempLink.setAttribute('download', `distribution.csv`)
    tempLink.click()
  }

  const handleBackClick = () => {
    onStepClick({ id: 2, href: 'upload' }, true)
  }

  const costPerSMS = userFullInfo.costPerSMS || 0.04
  const costPerRBM = userFullInfo.costPerRBM || 0.04
  const estimatedCost = (
    Math.max(costPerSMS, costPerRBM) * parseInt(stat.users)
  ).toFixed(2)

  const isScheduleValid = !scheduled || (scheduleDate && scheduleTime)
  const canLaunch = selectedCampaign && stat?.users > 0 && isScheduleValid

  return (
    <div className="py-6">
      <Modal {...modalContent} open={open} setOpen={setOpen} />
      <ResultModal
        {...resultContent}
        isLoading={isLoading}
        open={openResult}
        setOpen={setOpenResult}
        campaignLaunch={campaignLaunch}
        method={resultFunction ? goStatistics : null}
      />

      <div className="w-full max-w-2xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-lg font-medium text-gray-900">
            {i18n.t('review_and_send') || 'Review and send'}
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            {i18n.t('review_campaign_details') ||
              'Review your campaign details before sending'}
          </p>
        </div>

        {/* Resumen de la campaña */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="divide-y divide-gray-200">
            {/* Template */}
            <div className="px-6 py-4 flex items-center">
              <div className="flex-shrink-0">
                <DocumentTextIcon className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-4 flex-1">
                <p className="text-sm font-medium text-gray-500">
                  {i18n.t('campaign')}
                </p>
                <p className="mt-1 text-sm text-gray-900">
                  {selectedCampaign.name}
                </p>
              </div>
            </div>

            {/* Contactos */}
            <div className="px-6 py-4 flex items-center">
              <div className="flex-shrink-0">
                <UsersIcon className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-4 flex-1">
                <p className="text-sm font-medium text-gray-500">
                  {i18n.t('contacts')}
                </p>
                <p className="mt-1 text-sm text-gray-900">
                  {stat.users} {i18n.t('recipients') || 'recipients'}
                </p>
              </div>
            </div>

            {/* Precios */}
            <div className="px-6 py-4">
              <p className="text-sm font-medium text-gray-500 mb-3">
                {i18n.t('pricing') || 'Pricing'}
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 rounded-md p-3">
                  <p className="text-xs text-gray-500">{i18n.t('price_sms')}</p>
                  <p className="text-lg font-semibold text-gray-900">
                    {costPerSMS} €
                  </p>
                </div>
                <div className="bg-gray-50 rounded-md p-3">
                  <p className="text-xs text-gray-500">{i18n.t('price_rbm')}</p>
                  <p className="text-lg font-semibold text-gray-900">
                    {costPerRBM} €
                  </p>
                </div>
              </div>
              <div className="mt-3 bg-blue-50 rounded-md p-3">
                <p className="text-xs text-blue-600">
                  {i18n.t('estimated_max_cost') || 'Estimated max cost'}
                </p>
                <p className="text-xl font-bold text-blue-700">
                  {estimatedCost} €
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Excel CaixaBank: detalle de a quién se cerrará el flujo */}
        {excelJob && (
          <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <p className="text-sm font-medium text-gray-500 mb-1">
              Excel CaixaBank
            </p>
            <p className="text-xs text-gray-400">
              {excelJob.fileName} · se procesará
              {scheduled ? ' a la hora programada' : ' al lanzar'} (crea la campaña
              y cierra los flujos indicados)
            </p>
            <ExcelClosingSummary preview={excelJob.preview} />
          </div>
        )}

        {/* Bot Selector */}
        {userBots.length > 0 && (
          <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <label
              htmlFor="bot-select"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              {i18n.t('select_bot') || 'Select Bot'}
            </label>
            <select
              id="bot-select"
              value={selectedBotId || ''}
              onChange={(e) => setSelectedBotId(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-dark focus:ring-blue-dark sm:text-sm"
            >
              {userBots.map((bot) => (
                <option key={bot.id} value={bot.id}>
                  {bot.name} ({bot.provider === 'orange' ? 'Orange' : 'Google'})
                </option>
              ))}
            </select>
            <p className="mt-2 text-xs text-gray-500">
              {i18n.t('select_bot_description') ||
                'Choose which bot to use for this campaign'}
            </p>
          </div>
        )}

        {/* Forzar SMS */}
        <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center">
                <span className="text-sm font-medium text-gray-700">
                  {i18n.t('force_sms') || 'Force SMS delivery'}
                </span>
              </div>
              <p className="mt-1 text-xs text-gray-500">
                {i18n.t('force_sms_description') ||
                  'Send all messages via SMS even if recipients have RCS capability'}
              </p>
            </div>
            <button
              type="button"
              onClick={() => setForceSMS(!forceSMS)}
              className={classNames(
                forceSMS ? 'bg-blue-dark' : 'bg-gray-200',
                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-dark focus:ring-offset-2 ml-4'
              )}
            >
              <span
                className={classNames(
                  forceSMS ? 'translate-x-5' : 'translate-x-0',
                  'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                )}
              />
            </button>
          </div>
        </div>

        {/* Sync SFTP */}
        <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center">
                <span className="text-sm font-medium text-gray-700">
                  {i18n.t('sync_sftp_results') || 'Sync results by SFTP'}
                </span>
              </div>
              <p className="mt-1 text-xs text-gray-500">
                {i18n.t('sync_sftp_results_description') ||
                  'Automatically export deliveries and answers CSV to the SFTP server for this campaign'}
              </p>
            </div>
            <button
              type="button"
              onClick={() => setSyncSftpResults(!syncSftpResults)}
              className={classNames(
                syncSftpResults ? 'bg-blue-dark' : 'bg-gray-200',
                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-dark focus:ring-offset-2 ml-4'
              )}
            >
              <span
                className={classNames(
                  syncSftpResults ? 'translate-x-5' : 'translate-x-0',
                  'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                )}
              />
            </button>
          </div>
        </div>

        {/* Programación */}
        <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <CalendarIcon className="h-5 w-5 text-gray-400 mr-2" />
              <span className="text-sm font-medium text-gray-700">
                {i18n.t('schedule_campaign') || 'Schedule campaign'}
              </span>
            </div>
            <button
              type="button"
              onClick={() => setScheduled(!scheduled)}
              className={classNames(
                scheduled ? 'bg-blue-dark' : 'bg-gray-200',
                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-dark focus:ring-offset-2'
              )}
            >
              <span
                className={classNames(
                  scheduled ? 'translate-x-5' : 'translate-x-0',
                  'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                )}
              />
            </button>
          </div>

          {scheduled && (
            <div className="mt-4 grid grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="schedule-date"
                  className="block text-sm font-medium text-gray-700"
                >
                  {i18n.t('send_date') || 'Send date'}
                </label>
                <input
                  type="date"
                  id="schedule-date"
                  min={new Date().toISOString().split('T')[0]}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-dark focus:ring-blue-dark sm:text-sm"
                  value={scheduleDate}
                  onChange={(e) => setScheduleDate(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="schedule-time"
                  className="block text-sm font-medium text-gray-700"
                >
                  {i18n.t('send_time') || 'Send time'}
                </label>
                <input
                  type="time"
                  id="schedule-time"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-dark focus:ring-blue-dark sm:text-sm"
                  value={scheduleTime}
                  onChange={(e) => setScheduleTime(e.target.value)}
                />
              </div>
              {scheduled && (!scheduleDate || !scheduleTime) && (
                <p className="col-span-2 text-sm text-red-600">
                  {i18n.t('select_date_and_time') ||
                    'Please select both date and time'}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Confirmación */}
        <div className="mt-6 bg-yellow-50 rounded-lg border border-yellow-200 p-4">
          <div className="flex items-start">
            <input
              id="confirm-launch"
              type="checkbox"
              checked={confirmLaunch}
              onChange={(e) => setConfirmLaunch(e.target.checked)}
              className="h-4 w-4 text-blue-dark border-gray-300 rounded focus:ring-blue-dark mt-0.5"
            />
            <label
              htmlFor="confirm-launch"
              className="ml-3 text-sm text-yellow-800"
            >
              {i18n.t('confirm_send_campaign') ||
                `I confirm that I want to send this campaign to ${stat.users} contacts. This action cannot be undone.`}
            </label>
          </div>
        </div>

        {/* Botones de acción */}
        <div className="mt-8 flex justify-between">
          <button
            type="button"
            onClick={handleBackClick}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dark"
          >
            <ArrowLeftIcon className="-ml-1 mr-2 h-4 w-4" />
            {i18n.t('back') || 'Back'}
          </button>

          <div className="flex space-x-3">
            <button
              type="button"
              onClick={handleDistributionClick}
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dark"
            >
              {i18n.t('get_distribution') || 'Get distribution'}
            </button>

            <button
              type="button"
              disabled={!canLaunch || !confirmLaunch}
              onClick={handleLaunchClick}
              className={classNames(
                canLaunch && confirmLaunch
                  ? 'bg-green-600 text-white hover:bg-green-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed',
                'inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-150'
              )}
            >
              <RocketLaunchIcon className="-ml-1 mr-2 h-5 w-5" />
              {scheduled
                ? i18n.t('schedule') || 'Schedule'
                : i18n.t('launch') || 'Launch'}
            </button>
          </div>
        </div>

        {/* Mensaje de ayuda */}
        {(!canLaunch || !confirmLaunch) && (
          <p className="mt-3 text-sm text-gray-500 text-right">
            {!isScheduleValid
              ? i18n.t('complete_schedule') ||
                'Complete the schedule to continue'
              : !confirmLaunch
              ? i18n.t('confirm_to_launch') || 'Confirm the checkbox to launch'
              : ''}
          </p>
        )}
      </div>
    </div>
  )
}

export default Send
